import { useMemo } from 'react'

let DEFAULT_SETTINGS = {
  full_day_default: false,
  patient_default: 'new',
}

export default function useDataTransform(props, data) {
  return useMemo(() => {
    let settings = data?.[0] ?? {}
    return {
      id: settings.id ?? null,
      location_id: settings.location_id ?? null,
      full_day_default:
        settings.full_day_default ?? DEFAULT_SETTINGS.full_day_default,
      patient_default:
        settings.patient_default ?? DEFAULT_SETTINGS.patient_default,
    }
  }, [data])
}
